import { EventEmitter, Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map, Observable } from 'rxjs';

import { QuoteRequest, QuoteRequestsListItem, QuoteRequestsListResponse } from './quote-request.type';
import { OpenQuoteRequestResponse } from '../../dashboard/open-quote-requests-widget/quote-requests.types';
import { AbstractQuoteRequestsListService } from '@sbd-doug-frontend/shared/lib/shared-services/quote-requests-list.abstract.service';


@Injectable({ providedIn: 'root' })
export class QuoteRequestsListService extends AbstractQuoteRequestsListService {
  override totalQuoteRequests: WritableSignal<number> = signal<number>(0);
  override quoteRequests: WritableSignal<QuoteRequestsListItem[]> = signal<QuoteRequestsListItem[]>([]);
  override notFilterableFields: WritableSignal<string[]> = signal<string[]>([]);
  override triggerRefresh = new EventEmitter<void>();
  override isLoading: WritableSignal<boolean> = signal<boolean>(false);

  override getQuoteRequestsList(filters: any = {}): Observable<QuoteRequestsListItem[]> {
    const params = filters || {};
    this.isLoading.set(true);
    return this._httpClient
      .get <QuoteRequestsListResponse>(
        `${environment.apiBaseUrl}/v4/quote/requests`,
        { params },
      ).pipe(
        map((response) => {
          this.quoteRequests.set(response.data.quote_requests.quote_requests);
          this.totalQuoteRequests.set(response.data.quote_requests.total_quote_requests);
          this.notFilterableFields.set(response.data.not_filterable);
          this.isLoading.set(false);
          return response.data.quote_requests.quote_requests;
        }),
      );
  }


  loadQuoteRequest(quoteRequestId: number): Observable<QuoteRequestsListItem> {
    return this._httpClient
      .get<OpenQuoteRequestResponse>(
        `${environment.apiBaseUrl}/v4/quote/load-request/${quoteRequestId}`,
      ).pipe(
        map((response) => {
          if(!response.success) {
            this._cathyService.error(response.message);
          }
          return response.data.quote_request.quote_request;
        }),
      );
  }

}


